import { useQuery } from "react-query";
import { getPenCertificate } from "../../../api/geocode.api";
import { PenCertificate } from "../../../types/geocoding.types";

export const hasPenCertificateData = (
  penCertificate: PenCertificate | null | undefined
) =>
  !!penCertificate &&
  !!(
    penCertificate.energy_class ||
    penCertificate.valid_until ||
    penCertificate.heating_energy_consumption_kwh_m2_year ||
    penCertificate.heated_area_m2 ||
    penCertificate.heat_source
  );

export const usePenCertificate = (uniqueNr?: string) => {
  const query = useQuery(
    ["pen_certificate", uniqueNr],
    () => getPenCertificate(uniqueNr!),
    {
      enabled: !!uniqueNr,
    }
  );

  return {
    ...query,
    hasPenCertificate: hasPenCertificateData(query.data),
  };
};
